import { create } from 'zustand'
import { Coordinates } from '../../Util/Math/Coordinates'
import { FretBoardNote } from '../FretBoard/FretBoardV2'
import { FretBoardNoteCtrlMenuState } from './FretBoardNoteCtrlMenuState'
export interface FretBoardNoteCtrlMenuConfig{
    note:FretBoardNote|null,
    selectedNotes:FretBoardNote[]
    coordinates:Coordinates
    noteHider:Function
}
export const useFretBoardNoteCtrlMenuStore = create<FretBoardNoteCtrlMenuState>()(
  (setter) => new FretBoardNoteCtrlMenuState(setter)
)

export function useCtrlFretBoardNote(){
    const note:FretBoardNote|null = useFretBoardNoteCtrlMenuStore((state:FretBoardNoteCtrlMenuState)=>{
      return state.note
    }) 
    return note
}
export function useCtrlFretBoardSelectedNotes(){
    const notes:FretBoardNote[]|null = useFretBoardNoteCtrlMenuStore((state:FretBoardNoteCtrlMenuState)=>{
      return state.selectedNotes
    }) 
    return notes
}

export function useFretBoardNoteCtrlMenuCoordinates(){
    const coordinates:Coordinates = useFretBoardNoteCtrlMenuStore((state:FretBoardNoteCtrlMenuState)=>{
      return state.coordinates
    }) 
    return coordinates
}
export function useFretBoardNoteCtrlMenuRefresh(){
    const refresh:Function = useFretBoardNoteCtrlMenuStore((state:FretBoardNoteCtrlMenuState)=>{
      return state.refresh
    }) 
    return refresh
}
export function useFretBoardNoteCtrlMenuDrawLines(){
    const draw:Function = useFretBoardNoteCtrlMenuStore((state:FretBoardNoteCtrlMenuState)=>{
      return state.drawLines
    }) 
    return draw
}
export function useFretBoardNoteCtrlMenuIsOpen(){
    const open:boolean = useFretBoardNoteCtrlMenuStore((state:FretBoardNoteCtrlMenuState)=>{
      return state.isOpen
    }) 
    return open
}